import { Link } from "react-router-dom";
import DOMPurify from "dompurify";
import { ArrowLeft } from "lucide-react";
import { PageHero } from "./PageHero";
import { CtaBand } from "./CtaBand";
import { mediaUrl } from "../lib/api";
import { fmtDate } from "../lib/dates";
import { ShareButtons } from "./ShareButtons";

const COLOR = "#EE8445";

export const ActuArticle = ({ a, share = false }) => (
  <article data-testid="actu-article">
    <PageHero eyebrow={`Actus · ${a.published_at ? fmtDate(a.published_at) : "Non daté"}`} color={COLOR} title={a.title} lead={a.summary} testid="actu-hero" />
    <div className="mx-auto max-w-3xl px-5 lg:px-8 py-14 lg:py-20">
      {a.image_url && (
        <img src={mediaUrl(a.image_url)} alt={a.image_alt} data-testid="actu-image" className="w-full aspect-[16/9] object-cover mb-12" />
      )}
      <div data-testid="actu-content" className="enova-prose" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(a.content_html || "") }} />
      {share && <div className="mt-14 pt-8 border-t border-ink/10"><ShareButtons slug={a.slug} /></div>}
      <Link to="/realisations/actus" data-testid="actu-back-link" className="mt-10 inline-flex items-center gap-2 text-sm font-semibold underline underline-offset-4">
        <ArrowLeft size={15} /> Toutes les actualités
      </Link>
    </div>
    <CtaBand color={COLOR} />
  </article>
);
